import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FaixaDescargaCIF } from 'src/app/models/faixa-descarga-cif';

@Component({
  selector: 'app-cadastrar-faixa-descarga-cif-modal',
  templateUrl: './cadastrar-faixa-descarga-cif-modal.component.html',
  styleUrls: ['./cadastrar-faixa-descarga-cif-modal.component.scss']
})
export class CadastrarFaixaDescargaCifModalComponent implements OnInit {
  item: FaixaDescargaCIF;
  ultimaFaixa: FaixaDescargaCIF;
  itens: FaixaDescargaCIF[];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CadastrarFaixaDescargaCifModalComponent>
  ) {
    this.item = this.data.item;

    if (!this.item.ate) {
      this.ultimaFaixa = this.data.ultimaFaixa;
      this.itens = this.data.itens;

      if (this.ultimaFaixa.ate > 0) {
        this.item.de = this.ultimaFaixa.ate + 1;
      } else {
        this.item.de = 1;
      }
    }
  }

  ngOnInit(): void {
  }

  salvar() {
    this.dialogRef.close(this.item);
  }

  fechar() {
    this.dialogRef.close();
  }
}
